import PageHeading from './PageHeading';
import './PageHeading.scss';

export default PageHeading;
